(function() {
    const fullQueryString = window.location.search;
    
    if(fullQueryString) {
        const cleanString = fullQueryString.substring(1);
        if (!document.cookie.includes("full_query_string=")) {
            document.cookie = "full_query_string=" + encodeURIComponent(cleanString) + "; path=/; SameSite=Lax";
        }
    }
})();